const config={
    apiKey: "AIzaSyBih5SF6oFm0AjHt1bl-NWQ4GHPCUJoT9I",
    authDomain: "project-273723.firebaseapp.com",
    databaseURL: "https://project-273723.firebaseio.com",
    projectId: "project-273723",
    storageBucket: "project-273723.appspot.com",
    messagingSenderId: "761091480124",
    appId: "1:761091480124:web:64d67acbe04bdba86c0139",
    measurementId: "G-PNLR7EGE3W"
};

export default config;